import styled from 'styled-components';

export const PACKAGE_BRAND_ORANGE = '#C84B31';

// Màu theo tier lấy từ color style trong file design (Orange/05, Text/03, Yellow/06...)
export const TIER_THEME_COLORS = {
  bronze: { name: PACKAGE_BRAND_ORANGE, headBg: '#FFF4EF', bodyBg: '#FFFAF7', border: '#FFD9C1', badgeBg: '#FFD9C1', badgeText: PACKAGE_BRAND_ORANGE },
  silver: { name: '#64748B', headBg: '#EFF2F8', bodyBg: '#F8F9FC', border: '#E5E6EB', badgeBg: '#E2E8F0', badgeText: '#1D2129' },
  gold: { name: '#EBA33B', headBg: '#FDEECE', bodyBg: '#FFF9EC', border: '#FBE696', badgeBg: '#F6D465', badgeText: '#1D2129' },
};

export const TierGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
`;

export const TierCard = styled.div<{ themeKey: keyof typeof TIER_THEME_COLORS; $added?: boolean }>`
  border-radius: 8px;
  overflow: hidden;
  /* thân thẻ luôn nền nhạt theo màu tier, header đậm hơn một bậc; đã thêm vào ticket thì viền đậm 2px */
  background: ${({ themeKey }) => TIER_THEME_COLORS[themeKey].bodyBg};
  border: ${({ themeKey, $added }) => ($added ? `2px solid ${TIER_THEME_COLORS[themeKey].name}` : `1px solid ${TIER_THEME_COLORS[themeKey].border}`)};
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
  .tier-head {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: ${({ themeKey }) => TIER_THEME_COLORS[themeKey].headBg};
  }
  .tier-added-check {
    margin-left: auto;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ themeKey }) => TIER_THEME_COLORS[themeKey].name};
    color: #fff;
  }
  .tier-icon {
    width: 48px;
    height: 48px;
  }
  .tier-name {
    font-size: 1.5rem;
    font-weight: 600;
    color: ${({ themeKey }) => TIER_THEME_COLORS[themeKey].name};
  }
  .tier-caption {
    font-size: 0.875rem;
    letter-spacing: 2px;
    color: #64748B;
  }
  .tier-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
  }
  .tier-sessions {
    font-size: 2rem;
    font-weight: 600;
    color: #1D2129;
    padding-bottom: 12px;
    border-bottom: 1px solid #F1F5F9;
  }
  .tier-price-label {
    font-size: 1rem;
    color: #64748B;
  }
  .tier-price {
    font-size: 2.5rem;
    font-weight: 700;
    color: #1D2129;
  }
  .tier-value-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 1.25rem;
    color: #64748B;
  }
  .tier-original {
    text-decoration: line-through;
  }
  /* nhãn tiết kiệm to hơn 30% để nổi bật trên thẻ */
  .tier-save {
    padding: 8px 16px;
    border-radius: 100px;
    font-size: 1.4625rem;
    font-weight: 600;
    background: ${({ themeKey }) => TIER_THEME_COLORS[themeKey].badgeBg};
    color: ${({ themeKey }) => TIER_THEME_COLORS[themeKey].badgeText};
  }
  .tier-line {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1.25rem;
    color: #1D2129;
    img {
      width: 24px;
      height: 24px;
    }
    &.tier-per-session {
      color: ${PACKAGE_BRAND_ORANGE};
    }
  }
  .tier-add-button {
    margin-top: auto;
    height: 56px;
    border: none;
    border-radius: 100px;
    background: ${PACKAGE_BRAND_ORANGE};
    color: #fff;
    font-size: 1.25rem;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    /* tier đã có trên ticket: mờ theo màu tier và không bấm được */
    &:disabled {
      background: ${({ themeKey }) => TIER_THEME_COLORS[themeKey].name};
      opacity: 0.35;
      cursor: not-allowed;
    }
  }
`;
